// eslint-disable-next-line no-restricted-imports, monorepo/no-internal-import
import { useHydrationDone as useHydrationDoneTadarida } from '@aboutyou/lazy-imports/src/HydrationProvider'

export const useHydrationDone = useHydrationDoneTadarida
